import { Tooltip, TooltipProps } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

export interface ISsoDisabledActionTooltipProps {
  isUserLoggedAsOrySso: boolean | undefined;
  children: React.ReactElement;
  defaultTooltipTitle?: TooltipProps['title'];
}

export function SsoDisabledActionTooltip(props: ISsoDisabledActionTooltipProps) {
  if (props.isUserLoggedAsOrySso) {
    return (
      <Tooltip title={<FormattedMessage {...messages.ImsSsoTooltipNotAvailable} />}>
        <span>{props.children}</span>
      </Tooltip>
    );
  }
  if (props.defaultTooltipTitle) {
    return (
      <Tooltip title={props.defaultTooltipTitle}>
        <span>{props.children}</span>
      </Tooltip>
    );
  }
  return props.children;
}

export default SsoDisabledActionTooltip;
